import React, { Component } from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import { BeatLoader } from 'react-spinners';
import cx from "classnames";
import { cartRegister } from "../../services/cartRegister";
import { dataRegister } from "../../services/dataRegister";
import { langRegister } from "../../services/langRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import { salesChannelRegister } from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import { imagesRegister } from "../../services/imagesRegister";
import { quotesRegister } from "../../services/quotesRegister";
import Information from "../../components/information/component";
import BoosterHeader from "../../components/booster-header/component";
import { scraperRegister } from "../../services/scraperRegister";
import { themeRegister } from "../../services/themeRegister";
import { videoRegister } from "../../services/videoRegister";
import { tokenRegister } from "../../services/tokenRegister";
import Dropdown from "../../components/dropdown/component";
import { userRegister } from "../../services/userRegister";
import { flowRegister } from "../../services/flowRegister";

class BoosterTheme extends Component {

    constructor(props) {
        super(props);
        this.state = {
            themes: [],
            selected: null,
        };
    };

    componentDidMount() {
        let token = tokenRegister.getToken();
        if (!token) {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }
    }

    componentWillMount() {

        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/theme');
            ReactGA4.send({ hitType: "pageview", page: "/booster/theme" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }

        this.update.theme();

    }

    update = {
        theme: () => {
            if (themeRegister.getValue()) {
                this.setState({
                    selected: themeRegister.getTheme()
                }, () => {
                    this.update.themes();
                })
            } else {
                this.update.themes();
            }
        },
        themes: () => {

            let selected_type = themeRegister.getThemeType();
            let user = userRegister.getUser();

            let themes = [
                {
                    id: "property",
                    default: false,
                    display: true,
                    recommended: false,
                    options: [],
                    value: "-1",
                    disabled_type: false,
                    placeholder: "No extra",
                    type: salesChannelRegister.get('name'),
                    title: this.renders.text("item_4"),
                    title_italian: this.renders.text("item_7"),
                    subtitle: this.renders.text("item_8"),
                    image: "ab_theme_pif"
                },
                {
                    id: "promotion",
                    default: false,
                    display: true,
                    recommended: true,
                    options: [],
                    value: "-1",
                    disabled_type: true,
                    placeholder: "No extra",
                    type: salesChannelRegister.get('name'),
                    title: this.renders.text("item_5"),
                    title_italian: this.renders.text("item_7"),
                    subtitle: this.renders.text("item_9"),
                    image: "ab_theme_prf"
                },
                {
                    id: "broker",
                    default: false,
                    display: true,
                    recommended: false,
                    options: [],
                    value: "-1",
                    disabled_type: true,
                    placeholder: "",
                    type: salesChannelRegister.get('name'),
                    title: this.renders.text("item_13"),
                    title_italian: this.renders.text("item_7"),
                    subtitle: this.renders.text("item_11"),
                    image: "ab_theme_aif"
                },
                {
                    id: "agency",
                    default: false,
                    display: true,
                    recommended: false,
                    options: [],
                    value: "-1",
                    disabled_type: true,
                    placeholder: "",
                    type: salesChannelRegister.get('name'),
                    title: this.renders.text("item_14"),
                    title_italian: this.renders.text("item_7"),
                    subtitle: this.renders.text("item_12"),
                    image: "ab_theme_coi"
                },
                {
                    id: "basic",
                    default: true,
                    display: true,
                    options: [],
                    value: "-1",
                    disabled_type: true,
                    placeholder: "No extra",
                    type: salesChannelRegister.get('name'),
                    title: this.renders.text("item_6"),
                    subtitle: this.renders.text("item_10"),
                    image: "ab_theme_nd"
                }
            ];

            themes = themes.filter((item) => {
                if (item.id === "broker") {
                    if ((item.type === "propertybooster" || item.type === "boostabostad") && user && user.profile_image && user.profile_image !== "") {
                        return true
                    } else {
                        return false
                    }
                } else if (item.id === "agency") {
                    if ((item.type === "propertybooster" || item.type === "boostabostad") && user && user.logo_image && user.logo_image !== "" && user.socialData && user.socialData.branding) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return true
                }
            });

            /*
            //CHECK WHICH OPTIONS ARE AVAILABLE
            themes.map((item) => {
                if(user.profile_image && user.profile_image !== ""){
                    item.options.push({id: "agent_theme", title: "Agent image"});
                }
                if(user.logo_image && user.logo_image !== ""){
                    item.options.push({id: "agency_theme", title: "Company logo"});
                }
                if(item.options.length < 1){
                    item.disabled_type = true;
                }
            });

             */

            /*
            themes.map((item) => {
                if(item.id === this.state.selected){
                    let option_type = "-1";
                    item.options.map((option) => {
                        if(option.id === selected_type){
                            option_type = JSON.stringify(option);
                        }
                    });
                    item.value = option_type;
                }
            });
             */

            this.setState({
                themes: themes
            })
        }
    };

    functions = {
        select: (id, type) => {
            this.setState({ selected: id }, () => {

                videoRegister.remove();
                themeRegister.setTheme(id);
                themeRegister.setThemeType((type !== "-1" ? JSON.parse(type).id : "no_type"));

                //IF AGENCY THEME, UPDATE AD TITLES WITH COMPANY NAME
                if (id === 'agency') {

                    let user_data = userRegister.getUser();
                    if (user_data && user_data.billing_company) {
                        let name = user_data.billing_company;
                        let ads_title = flowRegister.getValue('display_region');
                        let industry = flowRegister.getValue('industry_name');
                        if (name.length > 24) {
                            name.trim();
                            name = name.substr(0, 24);
                            name = name + ".";
                        }
                        let ads_title_instagram = ads_title + " | " + name;
                        let ads_title_facebook = industry + " | " + ads_title + " | " + name;
                        let ads_title_google = industry + " | " + ads_title + " | " + name;
                        let ads_title_bing = industry + " | " + ads_title + " | " + name;
                        flowRegister.setValue("ads_title_facebook", ads_title_facebook);
                        flowRegister.setValue("ads_title_instagram", ads_title_instagram);
                        flowRegister.setValue("ads_title_google", ads_title_google);
                        flowRegister.setValue("ads_title_bing", ads_title_bing);

                        //FOR CAMPAIGN CREATION
                        flowRegister.setValue('company_name', name);

                    }
                } else {
                    //REVERT TITLES TO PRICE
                    flowRegister.setValue("ads_title_facebook", flowRegister.getValue('ads_title_facebook_original'));
                    flowRegister.setValue("ads_title_instagram", flowRegister.getValue('ads_title_instagram_original'));
                    flowRegister.setValue("ads_title_google", flowRegister.getValue('ads_title_google_original'));
                    flowRegister.setValue("ads_title_bing", flowRegister.getValue('ads_title_bing_original'));
                    flowRegister.setValue("company_name", flowRegister.getValue('company_name_original'));
                }

                setTimeout(() => {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/ads");
                }, 200);
            })
        },
        back: () => {
            let view = quotesRegister.getView();
            if (view === "custom") {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans-custom");
            } else {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans");
            }
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("signup-theme", item);
        },
        last: () => {
            return Math.abs(this.state.themes.filter((item) => {
                return item.display
            }).length % 2) == 1 && this.state.themes.length > 3;
        }
    };

    render() {
        return (
            <div>
                <BoosterHeader props={this.props} />
                <div className={Styles.containerOuter}>
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <div style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}>
                                {this.renders.text("item_3")}
                            </div>
                        </div>
                        <div className={Styles.optionsContainer}>
                            {
                                this.state.themes.filter((item) => {
                                    return item.display
                                }).map((item) => {
                                    return (
                                        <div className={Styles.optionsContainerItem}>
                                            <div className={Styles.optionsContainerItemInner}>
                                                {
                                                    item.recommended &&
                                                    <div
                                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { backgroundColor: '#E65032' } : {}}
                                                        className={Styles.optionsContainerItemInnerBadge}>
                                                        {this.renders.text("item_2")}
                                                    </div>
                                                }
                                                <div onClick={() => this.functions.select(item.id, item.value)}
                                                    className={cx(Styles.optionsContainerItemInnerLayer)}>
                                                    <div className={
                                                        cx(Styles.optionsContainerItemInnerTitle,
                                                            {
                                                                [Styles.optionsContainerItemInnerTitleDefault]: item.default,
                                                                //[Styles.optionsContainerItemInnerTitleDefaultYieldlock]: item.default && salesChannelRegister.get('name')==='yieldlock',
                                                            })
                                                    }>
                                                        {item.title}
                                                        {
                                                            item.title_italian &&
                                                            <div
                                                                className={Styles.optionsContainerItemInnerTitleItalian}>{item.title_italian}</div>
                                                        }
                                                    </div>
                                                    {
                                                        salesChannelRegister.get('name') === "propertybooster" &&
                                                        <img className={Styles.themeImage} src={require("../../assets/images/" + item.image + "_pb.png")} />
                                                    }
                                                    {
                                                        salesChannelRegister.get('name') === "boostabostad" &&
                                                        <img className={Styles.themeImage} src={require("../../assets/images/" + item.image + "_bb.png")} />
                                                    }
                                                    <div
                                                        style={salesChannelRegister.get('name') === 'yieldlock' ? {} : {}}
                                                        className={Styles.optionsContainerItemInnerSubtitle}>
                                                        {item.subtitle}
                                                    </div>
                                                </div>
                                                {
                                                    this.state.selected === item.id &&
                                                    <div onClick={() => this.functions.select(item.id, item.value)}
                                                        className={Styles.optionsContainerItemInnerActive} />
                                                }
                                            </div>
                                            {
                                                false &&
                                                <div className={Styles.optionsContainerItemDropdown}>
                                                    <Dropdown
                                                        options={item.options}
                                                        disabled={item.disabled_type}
                                                        placeholder={item.placeholder}
                                                        value={item.value}
                                                        onChange={(value) => {
                                                            item.value = value;
                                                            this.setState({
                                                                themes: this.state.themes
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    )
                                })
                            }
                            {
                                this.renders.last() &&
                                <div className={Styles.optionsContainerItemLast} />
                            }
                        </div>
                        {
                            <div
                                onClick={() => this.functions.back()}
                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                className={cx(Styles.backButton)}>
                                {this.renders.text("item_1")}
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default BoosterTheme;


// WEBPACK FOOTER //
// ./src/pages/booster-theme/component.js